import React from "react";
import PropTypes from "prop-types";

const BenefitCtaBlockSection = ({section}) => {
  let { content, colour, heading, bgColour, topMargin, bottomMargin } = section;

  return (
    <div className={`wrapper block-wrapper bg-${bgColour} ${topMargin} ${bottomMargin}`}>
      <div className="col-1 wrapper--inner flex flex-w-w flex-jc-sb">
        <div className={`col-1 flex flex-w-w flex-jc-sb border border-grey border-padded homejoin bg-${colour == 'white' ? 'grey' : 'white'}`}>
          <div className="col-1 col-lg-5-2 homejoin-cta">
            <h3 
              className={`h3 ff-ss color-${colour}`}
              dangerouslySetInnerHTML={{__html: heading}}></h3>
            <a href="https://www.consumer.org.nz/learn-more" className="btn-m-m btn-red">Learn more</a>
            <a href="https://www.consumer.org.nz/join" className={`btn-m-m btn-${colour}`}>Join Consumer</a>
          </div>
          <div className="col-1 col-lg-5-3 flex flex-w-w flex-jc-sb">
          {content.items.map((item) => {
            let content = item.content;
            return (
              <div
                key={item.id}
                className={`col-1 col-md-3-1 col-lg-3-1 flex flex-w-w flex-jc-sb direction-column justify-center align-center bg-${colour} homejoin-blocks`}
              >
                <img alt={content.image_alt} src={content.image} srcSet={content.image_srcset} vspace="10"/>
                <p className="h4 b">{content.label}</p>
              </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  )
}

BenefitCtaBlockSection.propTypes = {
  section: PropTypes.object.isRequired
}

export default BenefitCtaBlockSection;
